import { NOT_ACTIVE_ONLINE, NO_STOCK_NO_PRICE_PRODUCT, ONLINE_PRODUCT, STORE_PRODUCT } from "theme/config/constants";
import React from "react";
import AccordionWrapper from "theme/components/productPage/accordions/Accordions";
import AddToCart from "theme/components/productPage/AddToCart";
import AdditionalProducts from "theme/components/productPage/AdditionalProducts";
import AmountInput from "theme/components/products/AmountInput";
import { COMPARISON_PRICE_UNIT } from "theme/components/productPage/constants";
import CategoryLinks from "theme/components/productPage/CategoryLinks";
import Column from "theme/layouts/Column";
import Price from "theme/components/products/Price";
import PriceRecommended from "theme/components/products/PriceRecommended";
// import ProductVariantSelector from "theme/components/Variants/ProductVariantSelector";
import PropTypes from "prop-types";
import Row from "theme/layouts/Row";
import TextStyles from "theme/components/text/TextStyles";
import ThemeBox from "theme/components/boxes/ThemeBox";
import Waterfall from "theme/layouts/Waterfall";
import decodeHTMLEntities from "core-web/utils/decodeHTMLEntities";
import { getFlag } from "core-web/utils/getFlag";
import { getParametric } from "core-web/utils/storm";
import styleObjectToProps from "core-web/utils/styleObjectToProps";
import styled from "theme/libs/styled";
import { useSelector } from "react-redux";
import { useTheme } from "emotion-theming";
import { useTranslation } from "react-i18next";

const Wrapper = styled("article")`
    ${({ theme }) => theme.above.tabletLg} {
        padding: 95px 0 24px 24px;
    }
`;

const AddToCartWrapper = styled(Row)`
    position: sticky;
    width: auto;
    background-color: ${({ theme }) => theme.colors.white};
    gap: 16px;
    bottom: 0;
    padding: 16px 0 20px;

    ${({ theme }) => theme.above.tabletLg} {
        padding: 16px 0 24px;
    }
`;

const TextWrapper = styled(TextStyles)`
    ul {
        list-style-type: circle;
        padding-left: 16px;
        margin-left: 16px;

        > li {
            padding-left: 8px;
        }
    }
`;

const UspWrapper = styled("div")`
    background-color: ${({ theme }) => theme.colors.neutral_50};
    padding: 12px;
    border-radius: 12px;
    text-align: center;
`;

const Description = styled("div")`
    a {
        text-decoration: underline;
        transition: all ${({ theme }) => theme.transitions.primary};

        :hover {
            text-decoration-color: ${({ theme }) => theme.colors.black_30};
        }
    }
`;

const InfoboxWrapper = styled("div")`
    display: grid;
    gap: 16px;
    margin-bottom: 32px;

    ${({ theme }) => theme.above.tabletLg} {
        margin-bottom: 40px;
    }
`;

const InfoboxItem = styled(ThemeBox)`
    display: grid;
    width: 100%;
    padding: 16px 12px;
    border-radius: 8px;
    gap: 4px;

    & > p {
        hyphens: manual;
    }

    ${({ theme }) => theme.above.tabletLg} {
        padding: 12px 16px;
    }
`;

const getCurrentPricelistInfoBoxes = (pricelistCode, infoBoxes) => {
    if (!pricelistCode) {
        return [];
    }

    try {
        return infoBoxes.filter((infoBox) => {
            const isPricelistInfoBox = infoBox?.type === "pricelist";

            if (!isPricelistInfoBox) {
                return false;
            }

            const isManualCode = infoBox?.is_manual_code === "true";
            const boxPricelistCode = isManualCode ? infoBox?.manual_pricelist_code : infoBox?.automatic_pricelist_code;

            return boxPricelistCode === pricelistCode;
        });
    } catch (e) {
        console.log(e);
        return [];
    }
};

const getCurrentFlagInfoBoxes = (flags, infoBoxes) => {
    if (!flags) {
        return [];
    }

    try {
        return infoBoxes.filter((infoBox) => {
            const isFlagInfoBox = infoBox?.type === "flag";

            if (!isFlagInfoBox) {
                return false;
            }

            return flags?.some((flag) => flag.code === infoBox.flag?.code);
        });
    } catch (e) {
        console.log(e);
        return [];
    }
};

const ProductInformation = ({
    bestHistoricalPrice,
    includedProducts,
    // inStock,
    product,
    onQuantityChange,
    quantity,
    variants,
    selectedProduct,
    selectedProductVariants,
    selectProductVariantCallback,
    totalPricing,
    isQuantityPackage,
    ...rest
}) => {
    // let stockStatus;
    const { t } = useTranslation();
    const { colors } = useTheme();

    const ecommerceEnabled = useSelector(({ application }) => application?.ecommerceEnabled);
    const categories = useSelector(({ page }) => page.data?.product?.categories) || [];
    const description = useSelector(({ page }) => page.data?.product?.description) || "";
    const subHeader = useSelector(({ page }) => page.data?.product?.sub_header) || "";

    const isPackage = selectedProduct.isPackage;
    const formatedDescription = description.replaceAll("\\n", `<br>`);

    // const productType =
    //     getFlag(NO_STOCK_NO_PRICE_PRODUCT, selectedProduct.flags)?.code ||
    //     getFlag(NOT_ACTIVE_ONLINE, selectedProduct.flags)?.code ||
    //     getFlag(STORE_PRODUCT, selectedProduct.flags)?.code ||
    //     getFlag(ONLINE_PRODUCT, selectedProduct.flags)?.code;

    // const hasVariants = variants?.length;
    // const isStoreProduct = productType === STORE_PRODUCT || productType === NOT_ACTIVE_ONLINE;
    // const isOnlineProduct = productType === ONLINE_PRODUCT;

    // const isPackageWithVariants =
    //     includedProducts?.length > 1 && includedProducts?.some((product) => product.variants?.length > 1);
    // const showStoreStock = locale === "sv_se" && !isPackageWithVariants && !isOnlineProduct;

    const { vatRate } = totalPricing;
    // const { googleDiscountPrice, googleDiscountTimeStamp, specialPrice, specialPriceTimeStamp } = selectedProduct || {};

    let priceExVat = totalPricing.priceExVat;

    const standardPriceExVat =
        totalPricing.priceExVat > totalPricing.standardPriceExVat
            ? totalPricing.priceExVat
            : totalPricing.standardPriceExVat;

    const selectedProductVariantValues = Object.values(selectedProductVariants);
    const isVariantSelected = !!selectedProductVariantValues[0];
    const productName = isVariantSelected ? decodeHTMLEntities(selectedProduct.name) : decodeHTMLEntities(product.name);
    // const comparisonPriceUnit = getParametric(COMPARISON_PRICE_UNIT, selectedProduct)?.value;

    const infoboxes =
        useSelector(({ application }) => application.config?.options?.product_page?.information_boxes) || [];

    const infoboxesToShow = [
        ...getCurrentFlagInfoBoxes(selectedProduct?.flags, infoboxes),
        ...getCurrentPricelistInfoBoxes(selectedProduct?.price_list_code, infoboxes),
    ];

    // if (isPackage) {
    //     if (selectedProductVariantValues.every((packageProduct) => !!packageProduct)) {
    //         [stockStatus] = getPackageStockStatus(selectedProductVariantValues);
    //     }
    // } else {
    //     stockStatus = getProductStockStatus(selectedProduct?.onHand);
    // }

    return (
        <Wrapper {...rest}>
            <TextStyles
                as="h1"
                textStyles={["Myriad Pro/24-130-semibold", null, null, null, "Myriad Pro/28-130-semibold"]}
                mb={["24px", null, null, null, "20px"]}
            >
                {productName}
            </TextStyles>

            <Waterfall rowGap="32px">
                {ecommerceEnabled && (
                    <>
                        <Column gap="4px">
                            <Price
                                price={totalPricing.priceExVat || totalPricing.priceIncVat}
                                priceListId={totalPricing.priceListId || selectedProduct.price_list_id}
                                showFromPrice={!isVariantSelected}
                                priceExVat={priceExVat}
                                standardPriceExVat={standardPriceExVat}
                                vatRate={vatRate}
                                // skipDiscountCheck={!!googleDiscountPrice || !!specialPrice}
                                textStyles={["Myriad Pro/22-100", null, null, null, "Myriad Pro/24-100"]}
                            />
                            {vatRate > 1 && (
                                <TextStyles textStyles="Myriad Pro/14-100" color={colors.neutral_600}>
                                    {t("views.product.price_incl_vat")}
                                </TextStyles>
                            )}
                        </Column>
                        {/* {selectedProduct.recommendedPriceExVat > priceExVat && (
                            <PriceRecommended
                                catalogPriceExVat={selectedProduct.catalogPriceExVat}
                                comparisonPriceUnit={comparisonPriceUnit}
                                priceExVat={selectedProduct.recommendedPriceExVat}
                                vatRate={vatRate}
                                mt="4px"
                            />
                        )} */}
                    </>
                )}

                {subHeader && (
                    <TextWrapper
                        as="div"
                        dangerouslySetInnerHTML={{ __html: subHeader }}
                        {...styleObjectToProps(["Myriad Pro/16-120", null, null, null, "Myriad Pro/18-140"])}
                    />
                )}
                {/* TODO: Custom message box */}
                {!!includedProducts.length && (
                    <AdditionalProducts
                        products={includedProducts}
                        type="package"
                        selectProductVariantCallback={selectProductVariantCallback}
                        selectedProductVariants={selectedProductVariants}
                        heading={t("pdp.package_offer")}
                    />
                )}

                {description && (
                    <Column gap="24px">
                        <TextStyles as="h2" pt="24px" textStyles="Myriad Pro/20-100-semibold">
                            {t("views.product.headings.description")}
                        </TextStyles>

                        <Description
                            dangerouslySetInnerHTML={{ __html: formatedDescription }}
                            {...styleObjectToProps("Myriad Pro/18-140")}
                        />
                    </Column>
                )}

                <AccordionWrapper product={product} selectedVariant={selectedProductVariants[product.id]} />
                <CategoryLinks />

                {ecommerceEnabled && (
                    <AddToCartWrapper>
                        <AmountInput
                            isPdp
                            defaultValue={quantity ? parseInt(quantity, 10) : 1}
                            productId={selectedProduct?.id}
                            minLength={1}
                            onChange={onQuantityChange}
                        />
                        <AddToCart
                            // inStock={inStock}
                            isQuantityPackage={isQuantityPackage}
                            isPackage={isPackage}
                            mainProduct={product}
                            productId={product.id}
                            quantity={quantity}
                            selectedProductVariants={selectedProductVariants}
                        />
                    </AddToCartWrapper>
                )}
            </Waterfall>

            {ecommerceEnabled && (
                <UspWrapper>
                    <TextStyles textStyles="Myriad Pro/14-100-semibold" color={colors.neutral_600}>
                        {t("views.product.free_shipping_info")}
                    </TextStyles>
                </UspWrapper>
            )}

            {/* {!!hasVariants && (
                <ProductVariantSelector
                    mb="40px"
                    productId={product.id}
                    variants={variants}
                    callback={selectProductVariantCallback}
                    selectedVariant={selectedProductVariants[product.id]}
                />
            )} */}

            {!!infoboxesToShow.length && (
                <InfoboxWrapper>
                    {infoboxesToShow.map((infobox) => (
                        <InfoboxItem
                            key={`${infobox.type}_${infobox.text}`}
                            text={infobox.text}
                            boxTheme={infobox.box_theme}
                            textStyles="Myriad Pro/14-140"
                        />
                    ))}
                </InfoboxWrapper>
            )}
        </Wrapper>
    );
};

ProductInformation.propTypes = {
    // bestHistoricalPrice: PropTypes.number,
    includedProducts: PropTypes.array,
    inStock: PropTypes.oneOfType([PropTypes.number, PropTypes.bool]),
    isQuantityPackage: PropTypes.bool.isRequired,
    onQuantityChange: PropTypes.func.isRequired,
    product: PropTypes.object.isRequired,
    quantity: PropTypes.number,
    selectedProduct: PropTypes.object,
    selectedProductVariants: PropTypes.object,
    selectProductVariantCallback: PropTypes.func,
    totalPricing: PropTypes.object.isRequired,
    variants: PropTypes.array.isRequired,
};

ProductInformation.defaultProps = {
    // bestHistoricalPrice: null,
    inStock: null,
    includedProducts: [],
    quantity: null,
    selectProductVariantCallback: null,
    selectedProduct: {},
    selectedProductVariants: {},
};

export default ProductInformation;
